import { AdminSalesScreen } from '@features/admin/ui/AdminSalesScreen'

export function VendasPage() {
  return <AdminSalesScreen />
}
